<div class="measure-logic-modal">
  <div class="modal-header">
    <div class="header-content">
      <h1 class="modal-title">{{ data.measureCode }}: Measure Logic Report</h1>
      <p class="modal-subtitle">Patient MRN: {{ data.patientMRN }} (ID: {{ data.patientID }})</p>
    </div>
    <button mat-icon-button class="close-button" (click)="onClose()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-content" *ngIf="!isLoading; else loading">
    <div class="info-banner" *ngIf="patientData.length > 0">
      <mat-icon class="info-icon">info</mat-icon>
      <span>Green highlights show satisfied components and evidence groups</span>
    </div>

    <div class="components-section" *ngIf="componentArray.length > 0">
      <div
        *ngFor="let item of componentArray; let compIndex = index"
        class="component-card"
        [class.component-hit]="item[1].isHit">

        <!-- Component Header -->
        <div class="component-header" (click)="toggleComponent(item[0])">
          <div class="component-header-left">
            <span class="component-badge" [class.badge-hit]="item[1].isHit">
              {{ getComponentName(item[0]) }}
            </span>
            <span class="hit-indicator" *ngIf="item[1].isHit">
              <mat-icon class="hit-icon">check_circle</mat-icon>
              Hit
            </span>
          </div>
          <div class="component-header-right">
            <span class="component-stat">{{ getGroupArray(item[1]).length }} Groups</span>
            <span class="component-stat">{{ getTotalCodesInComponent(item[1]) }} Codes</span>
            <mat-icon class="expand-icon">
              {{ isComponentExpanded(item[0]) ? 'expand_less' : 'expand_more' }}
            </mat-icon>
          </div>
        </div>

        <!-- Component Logic -->
        <div class="component-logic">
          <div class="logic-label">Component Evidence Group Logic</div>
          <div class="logic-content">
            <code>{{ item[1].logic }}</code>
          </div>
        </div>

        <!-- Evidence Groups -->
        <div class="evidence-groups" *ngIf="isComponentExpanded(item[0])">
          <div
            *ngFor="let group of getGroupArray(item[1])"
            class="evidence-group"
            [class.group-hit]="group[1].isHit">

            <!-- Group Header -->
            <div class="group-header" (click)="toggleGroup(item[0], group[0])">
              <div class="group-header-left">
                <span class="group-name" [class.group-name-hit]="group[1].isHit">
                  {{ group[0] }}
                </span>
                <mat-icon class="hit-icon-small" *ngIf="group[1].isHit">check_circle</mat-icon>
                <span class="group-badge" [class.group-badge-hit]="group[1].isHit">
                  {{ group[1].codes.length }} codes
                </span>
              </div>
              <mat-icon class="expand-icon-small">
                {{ isGroupExpanded(item[0], group[0]) ? 'expand_less' : 'expand_more' }}
              </mat-icon>
            </div>

            <!-- Group Description -->
            <div class="group-description">
              {{ group[1].description }}
            </div>

            <!-- Codes Table -->
            <div class="codes-table-container" *ngIf="isGroupExpanded(item[0], group[0])">
              <table mat-table [dataSource]="group[1].codes" class="codes-table">

                <!-- Code Column -->
                <ng-container matColumnDef="code">
                  <th mat-header-cell *matHeaderCellDef>Code</th>
                  <td mat-cell *matCellDef="let code" class="code-cell">{{ code.code }}</td>
                </ng-container>

                <!-- Type Column -->
                <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef>Type</th>
                  <td mat-cell *matCellDef="let code">
                    <span class="type-badge">{{ code.shortname }}</span>
                  </td>
                </ng-container>

                <!-- OID Column -->
                <ng-container matColumnDef="oid">
                  <th mat-header-cell *matHeaderCellDef>OID</th>
                  <td mat-cell *matCellDef="let code" class="oid-cell">{{ code.oid }}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="no-data" *ngIf="componentArray.length === 0">
      <mat-icon class="no-data-icon">info_outline</mat-icon>
      <p>No measure data available</p>
    </div>
  </div>

  <ng-template #loading>
    <div class="loading-container">
      <div *ngIf="!errorMessage">
        <mat-spinner diameter="50"></mat-spinner>
        <p>Loading measure logic data...</p>
      </div>
      <div *ngIf="errorMessage" class="error-message">
        <mat-icon class="error-icon">error_outline</mat-icon>
        <p>{{ errorMessage }}</p>
        <button mat-raised-button color="primary" (click)="loadData()">Retry</button>
      </div>
    </div>
  </ng-template>
</div>
